export function isMatchIndexFilter(filter) {
    return filter.equals !== undefined;
}
export function isRangeIndexFilter(filter) {
    return (filter.gte !== undefined ||
        filter.lte !== undefined ||
        filter.gt !== undefined ||
        filter.lt !== undefined);
}
export function isCompoundIndexFilter(filter) {
    return !!filter.match;
}
export function isStartsWithIndexFilter(filter) {
    return filter.startsWith !== undefined;
}
export function isSortIndexFilter(filter) {
    return (!isRangeIndexFilter(filter) &&
        !isMatchIndexFilter(filter) &&
        !isCompoundIndexFilter(filter) &&
        !isStartsWithIndexFilter(filter) &&
        filter.order);
}
//# sourceMappingURL=indexFilters.js.map